import {MAX_CACHED_RESULTS} from '../constants';

import type {CachedItem} from '../typedef';

export const removeExtraCachedItems = <Data>(data: CachedItem<Data>[]) => (
    data.length >= MAX_CACHED_RESULTS ? data.slice(1) : data
);
